module.exports = __webpack_public_path__ + "static/media/mens-health-services.f34ad54b.jpeg";